module.exports = __webpack_public_path__ + "./docs/img/big-icon-class.dad7ea058bc5cd99f3a075839ef69704.svg";